import React, { Component } from 'react';
import { Button } from "reactstrap";
import { faCircleNotch } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";

class GiveMeMoreButton extends Component {
    render() {
        const disabled = this.props.disabled || false;

        return (
            <div className="text-center">
                {this.props.loading
                    ? <FontAwesomeIcon icon={faCircleNotch} spin />
                    : <Button onClick={() => this.props.onClick()} disabled={disabled} className="btn btn-line-warning">
                        <FormattedMessage
                            id="app.give_me_more"
                            defaultMessage="Give me more"
                        />
                    </Button>
                }
            </div>
        )
    }
}

export default GiveMeMoreButton;
